import { Arrow, Content, Portal, Provider, Root, Trigger } from '@radix-ui/react-tooltip';
import { type HTMLAttributes, type ReactElement, cloneElement, useState } from 'react';

export function LazyTooltip(props: { children: ReactElement; text: string }) {
  const { children, text } = props;
  const [renderTooltip, setRenderTooltip] = useState(false);
  if (!renderTooltip) {
    return cloneElement(children, {
      onMouseEnter: () => {
        setRenderTooltip(true);
      },
    } as HTMLAttributes<HTMLElement>);
  }
  return (
    <Provider>
      <Root>
        <Trigger asChild onMouseLeave={() => setRenderTooltip(false)}>
          {children}
        </Trigger>
        <Portal>
          <Content className="bg-v1-slate12 w-auto rounded-md px-2 py-1">
            <p className="text-v1-slate1 text-xs font-normal">{text}</p>
            <Arrow className="fill-v1-slate12" />
          </Content>
        </Portal>
      </Root>
    </Provider>
  );
}
